module.exports = __webpack_public_path__ + "static/24th-43ba00e4ff4701b3c84feca212b0982c.png";